import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import Loaderspinner from "../Loader";
import { Analyticsdata } from "../../Pages/Utils/utils";
import { useLocation } from "react-router-dom";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const Analytics = () => {
  const location = useLocation();
  const pathname = location.pathname;
  const routename = pathname.split("/")[1];

  const [typeStatus, setTypeStatus] = useState("daily");
  const [loading, setLoading] = useState(false);
  const [chartData, setChartData] = useState({ labels: [], datasets: [] });


  const userType = routename === "borrower" ? "raiser" : "deal";

  const fetchData = async (type) => {
    try {
      setLoading(true);
      const res = await Analyticsdata(type, userType);
      const labels = res.data.map((item) => item.label);
      const counts = res.data.map((item) => item.count);

      setChartData({
        labels,
        datasets: [
          {
            label: "Listing Data",
            data: counts,
            backgroundColor: "rgba(75, 192, 192, 0.2)",
            borderColor: "rgba(75, 192, 192, 1)",
            borderWidth: 1,
          },
        ],
      });
    } catch (error) {
      console.error("Error fetching analytics data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(typeStatus);
    // console.log("routename:", routename, "| userType:", userType);
  }, [typeStatus, routename]);

  const options = {
    responsive: true,
    scales: {
      y: {
        beginAtZero: true,
      },
    },
  };

  return (
    <>
      {loading && <Loaderspinner />}
      <div className="g-sidenav-show bg-gray-100 min-vh-100">
        <div id="wrapper">
          <main className="border-radius-lg">
            <div className="container-fluid mt--6">
              <div className="row">
                <div className="col">
                  <div className="card">
                    <div className="card-header border-0 d-flex justify-content-between align-items-center">
                      <h5 className="mb-0">Analytics</h5>
                      <select
                        className="custom-select-dropdown"
                        value={typeStatus}
                        onChange={(e) => setTypeStatus(e.target.value)}
                      >
                        <option value="daily" className="option">Daily</option>
                        <option value="weekly" className="option">Weekly</option>
                        <option value="monthly" className="option">Monthly</option>
                      </select>
                    </div>
                    <div className="card-body">
                      <Bar data={chartData} options={options} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </>
  );
};

export default Analytics;
